import download from 'downloadjs';
import { getAuthHeadersFromCookie } from 'lib/AuthClient/cookie';
import { settings } from '../settings';
import Swal from 'sweetalert2';

export const downloadFile = async (
  path: string,
  filename?: string
): Promise<void> => {
  const url = `${settings.newApiUrl}/${path}`;

  const headers: Record<string, string> = {};
  const auth = getAuthHeadersFromCookie()?.Authorization;
  if (auth) {
    headers.Authorization = auth;
  }

  const res = await fetch(url, {
    method: 'GET',
    headers,
  });

  if (res.ok) {
    download(await res.blob(), filename);
  } else {
    Swal.fire('Something went wrong, please try again', null, 'error');
  }
};
